module.exports = __webpack_public_path__ + "static/media/neutral.0f9299a1.svg";